import { useEffect, useRef } from "react";

/**
 * Saves the latest draft on unmount (drawer close) and, when the parent
 * registers it, when the analyst leaves the tab. `flush` is recomputed each
 * render, so the ref always runs against current values.
 */
export function useAutosaveFlush(
  flush: VoidFunction,
  registerFlush?: (flush: VoidFunction) => void,
): void {
  const flushRef = useRef(flush);
  flushRef.current = flush;

  useEffect(() => () => flushRef.current(), []);
  useEffect(() => {
    registerFlush?.(() => flushRef.current());
  }, [registerFlush]);
}
